import React from "react";
import Recommend from "../../Components/B2B/Recommend";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const RecommendPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <Recommend date={query.date} />
    </React.Fragment>
  );
};

export default RecommendPage;
